import _ from 'underscore';

import { PostAddUpsellType } from '@biteinc/enums';

const recursivelyGetModsByMagicCopyKey = (menuItemOrModId) => {
  const modsByMagicCopyKey = {};
  const menuItemOrMod = app.menuItemList?.get(menuItemOrModId) ?? app.modList?.get(menuItemOrModId);
  if (menuItemOrMod) {
    const priceOptions = menuItemOrMod.get('priceOptions') || [];
    priceOptions?.forEach((po) => {
      const addonSetIds = po.addonSetIds || [];
      addonSetIds?.forEach((modGroupId) => {
        const modGroup = app.modGroupList?.get(modGroupId);
        if (modGroup) {
          const items = modGroup.get('items') || [];
          items?.forEach((item) => {
            const mod = app.modList?.get(item._id);
            if (mod) {
              const magicCopyKey = mod.get('magicCopyKey');
              if (magicCopyKey && !modsByMagicCopyKey[magicCopyKey]) {
                modsByMagicCopyKey[magicCopyKey] = mod;
              }

              const childModsByMagicCopyKey = recursivelyGetModsByMagicCopyKey(mod.get('_id'));
              Object.assign(modsByMagicCopyKey, childModsByMagicCopyKey);
            }
          });
        }
      });
    });
  }
  return modsByMagicCopyKey;
};

app.PostAddUpsellView = app.AccordionFieldView.extend({
  className() {
    return `${app.AccordionFieldView.prototype.className.apply(this)} post-add-upsell-panel`;
  },

  initialize(options) {
    _.extend(options || {}, {
      getTitle: (fieldGroupView) => {
        const postAddUpsell = fieldGroupView.getValue();
        if (!postAddUpsell) {
          return 'Unset';
        }
        let title;
        switch (postAddUpsell.type) {
          case PostAddUpsellType.Modifier:
            title = 'Modifier Upsell';
            break;
          case PostAddUpsellType.Section:
            title = 'Section Upsell';
            break;
          default:
            title = 'Unknown';
        }
        if (
          postAddUpsell.type === PostAddUpsellType.Modifier &&
          postAddUpsell.modifierMagicCopyKey
        ) {
          const modName = app.modList?.models
            ?.find((mod) => mod.get('magicCopyKey') === postAddUpsell.modifierMagicCopyKey)
            ?.displayName();
          if (modName) {
            title += ` - ${modName}`;
          }
        }
        if (postAddUpsell.type === PostAddUpsellType.Section && postAddUpsell.sectionIds?.length) {
          title += ` - ${postAddUpsell.sectionIds.length} sections`;
        }
        if (postAddUpsell.menuItemIds.length) {
          title += ` - ${postAddUpsell.menuItemIds.length} menu items`;
        }
        return title;
      },
      newValue: () => {
        return {
          type: PostAddUpsellType.Modifier,
          menuItemIds: [],
          modifierMagicCopyKey: null,
        };
      },
      setSetValueHandlers: (fieldGroupView) => {
        const menuItemIdsFieldView = fieldGroupView.fieldViewsByField.menuItemIds;
        const modifierMagicCopyKeyFieldView = fieldGroupView.fieldViewsByField.modifierMagicCopyKey;

        if (menuItemIdsFieldView && modifierMagicCopyKeyFieldView) {
          const updateModifierCollection = () => {
            const menuItemIds = fieldGroupView.getValueForFieldName('menuItemIds') || [];

            // Get all modifiers from selected menu items
            const modsByMagicCopyKey = menuItemIds.reduce((acc, menuItemId) => {
              return Object.assign(acc, recursivelyGetModsByMagicCopyKey(menuItemId));
            }, {});

            // Create collection from unique modifiers
            const modifierCollection = new app.AbstractCollection(
              Object.values(modsByMagicCopyKey).map((mod) => ({
                _id: mod.get('magicCopyKey'),
                name: mod.displayName(),
              })),
            );

            // Update the dropdown collection
            modifierMagicCopyKeyFieldView.collection = modifierCollection;
            const currentValue = modifierMagicCopyKeyFieldView.getValue();

            // Reset the value if current selection is not in the new collection
            if (
              currentValue &&
              !modifierCollection.models.find(
                (item) => item.id.toString() === currentValue.toString(),
              )
            ) {
              modifierMagicCopyKeyFieldView.value = null;
              modifierMagicCopyKeyFieldView.valueModel = null;
            }

            // Refresh the dropdown to show updated collection
            modifierMagicCopyKeyFieldView._setupDropdown(modifierCollection);
          };

          // Listen to changes on menuItemIds field
          fieldGroupView.listenTo(
            menuItemIdsFieldView,
            app.FieldView.Events.FieldDidChangeValue,
            updateModifierCollection,
          );

          // Initial update
          updateModifierCollection();
        }
      },
      templateData: {
        title: options.schema.displayName || options.field,
        buttonText: 'new post add upsell',
        emptyText: 'no post add upsell yet',
      },
    });

    app.AccordionFieldView.prototype.initialize.apply(this, arguments);
  },
});
